module.exports = __webpack_public_path__ + "static/media/1009389.9ab2f0f6.png";